export default __webpack_public_path__ + "static/media/alphastar-academy-icon.d73db11b.svg";